import React from "react";
import {
  AppBar,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  IconButton,
  Link,
  Paper,
  Toolbar,
  Tooltip,
  Typography
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { uniqBy } from "lodash/array";
import RefreshIcon from "@material-ui/icons/Refresh";
import { PaperComponent, getToolTipText } from "../../../utils/helper";
import DownloadSSRSPopUp from "../button-download-popup";
import { TOOLTIP_LABEL } from "../../../constants/appConstants";
import FilterOff from "../../../public/img/common/filterOff.svg";
import sortBy from "lodash/sortBy";
import { filterTableRows } from "../../../utils/filtered";
import TableHeaderWithFilter from "../table-header-filter";
import PaginationControlled from "../pagination/pagination";
import ConfirmDialog from "../Dailogbox/ConfirmDailog";
import commonLabels from "../../../constants/messageConstants";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { getArrayIndex } from "../../../utils/lodash";
import SaveIcon from "@material-ui/icons/Save";
import VirtualizedAutocomplete from "../VirtualizedAutocomplete/VirtualizedAutocomplete";
import CancelIcon from "@material-ui/icons/Cancel";
import { convertIntoDDFormat } from "../../../utils/generic";
import { ShowToast, toastType } from "../../../utils/toast-service";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import LabelWithSwitch from "../switchWithLabel/switchWithLabel";
import { getFormattedData } from "../../../utils/formatData";
import _ from "lodash";


class TableWithFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      colFilteredObj: [],
      isShowColFilter: true,
      refreshFilteredObj: false,
      reload: props.reloadTable || false,
      keepFilterData: false,
      selectedSource: [],
      clearData: false,
      selectedIds: {},
      sortByColKey: "",
      pageNo: 0,
      rowsPerPagination: 25,
      isOpenDeleteConfirmationPanel: false,
      data: null,
      isDetailsPopup: false,
      selectedData: [],
      columnHeader: "",
      isEdit: false,
      selectedRecipientId: [],
      masterData: props.masterData,
      isOpenActivateDeactivatePanel: false,
      activeDeactivateMessage: "",
      originalData: props.originalData || []
    };
  }

  // get values from props and set to state.
  static getDerivedStateFromProps(newProps, state) {
    let finalReturnObj = null;
    if (newProps.masterData !== state.masterData ||
        newProps.reloadTable !== state.reload  ||
        newProps.originalData !== state.originalData) {
      if (newProps.masterData !== state.masterData) {
        finalReturnObj = {
          masterData: newProps.masterData
        };
      }
     

      if (newProps.reloadTable !== state.reload) {
        if (finalReturnObj !== null) {
          finalReturnObj.reload = newProps.reloadTable;
        } else {
          finalReturnObj = {
            reload: newProps.reloadTable
          };
        }
      }

      if (newProps.originalData !== state.originalData) {
        if (finalReturnObj !== null) {
          finalReturnObj.originalData = newProps.originalData;
        } else {
          finalReturnObj = {
            originalData: newProps.originalData
          };
        }
      }
      return finalReturnObj;
    } else {
      return state;
    }
  }
  /**
   * update the selected filters
   * @param {*} key
   * @param {*} value
   * @param {*} filterType
   */
  updateColumnFilter = (key, value = "", filterType) => {
    const { colFilteredObj, selectedIds } = this.state;
    const index = getArrayIndex(colFilteredObj, { keyName: key });
    if (index !== -1) {
      colFilteredObj[index] = {
        keyName: key,
        value,
        filterType: filterType || "string"
      };
      key &&
        this.setState({
          colFilteredObj: colFilteredObj,
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0
        });
    } else {
      key &&
        this.setState({
          colFilteredObj: [
            ...colFilteredObj,
            { keyName: key, value, filterType: filterType || "string" }
          ],
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0
        });
    }
  };

  /**
   * get filtered data depends upon conditions
   * @param {*} data
   * @returns
   */
  getFilteredData = data => {
    const { colFilteredObj, sortByColKey } = this.state;
    const fData = sortBy(
      filterTableRows(data, colFilteredObj),
      x => x[sortByColKey]
    );
    return fData || [];
  };

  /**
   * update page count call on pagination
   * @param {*} pageNo
   * @param {*} rowsPerPagination
   */
  updateRowCount = (pageNo, rowsPerPagination) => {
    this.setState({ pageNo, rowsPerPagination });
  };

  /**
   * render action according to configurations
   * @param {*} col
   * @param {*} row
   * @returns
   */
  renderActionColumn = (col, row) => {
    const {
      toolTipData,
      editRecord,
      viewDetails,
      visibilityAction
    } = this.props;
    return col.iconType.map((icon) => {
      switch (icon.action) {
        case "edit":
          if (visibilityAction.isActionVisible === true && !row[icon.isIconVisibleKey]) {
            return (
              <Tooltip title={getToolTipText(toolTipData, TOOLTIP_LABEL.EDIT)}>
                <IconButton
                  aria-label={"refreshData"}
                  size={"small"}
                  onClick={() => editRecord(row)}
                >
                  <EditIcon
                    fontSize={"small"}
                    size={"small"}
                    style={{ cursor: "pointer" }}
                  />
                </IconButton>
              </Tooltip>
            );
          } else {
            return <></>;
          }

        case "delete":
          if (visibilityAction.isActionVisible === true) {
            return (
              <Tooltip
                title={getToolTipText(toolTipData, TOOLTIP_LABEL.DELETE)}
              >
                <IconButton
                  aria-label={"refreshData"}
                  size={"small"}
                  onClick={() => {
                    this.openDeleteConfirmationPanel(row, true);
                  }}
                >
                  <DeleteIcon
                    fontSize={"small"}
                    size={"small"}
                    style={{ cursor: "pointer" }}
                  />
                </IconButton>
              </Tooltip>
            );
          } else {
            return <></>;
          }
        case "view":
          return (
            <Tooltip title={getToolTipText(toolTipData, TOOLTIP_LABEL.VIEW)}>
              <IconButton
                aria-label={"refreshData"}
                size={"small"}
                onClick={viewDetails}
              >
                <VisibilityIcon
                  fontSize={"small"}
                  size={"small"}
                  style={{ cursor: "pointer" }}
                />
              </IconButton>
            </Tooltip>
          );
        case "activeDeactivate":
          if (visibilityAction.isActionVisible === true && !row[icon.isIconVisibleKey]) {
            return (
               <LabelWithSwitch
                  key={row[col.keyName]}
                  tooltipTitle={getToolTipText(toolTipData, row.IsActive === "Yes" ? TOOLTIP_LABEL.INACTIVE : TOOLTIP_LABEL.ACTIVE)}
                  selectedValue={row.IsActive === "Yes"}
                  onChange={() => {
                    this.openActivateDeactivateConfirmationPanel(row, true);
                  }}
                  isConfirm
                  inlineStyle={{ paddingLeft: "0.4em", paddingTop: "0.5em" }}
               />
            );
          } else {
            return <></>;
          }
        }
    });
  };

  /**
   * call on clear filter
   */
  clearFilter = () => {
    const { refreshFilteredObj } = this.state;
    this.setState({
      colFilteredObj: [],
      clearData: true,
      refreshFilteredObj: !refreshFilteredObj,
      sortByColKey: "",
      selectedIds: {}
    });
  };

  /**
   * delete confirmation panel
   * @param {*} data
   * @param {*} value
   */
  openDeleteConfirmationPanel = (data, value) => {
    this.setState({
      data: data,
      isOpenDeleteConfirmationPanel: value
    });
  };

  /**
   * delete record
   * @param {*} isDelete
   */
  deleteRecord = isDelete => {
    const { deleteRecord } = this.props;
    const { data } = this.state;
    if (isDelete) {
      this.setState(
        {
          isOpenDeleteConfirmationPanel: false,
          data: null
        },
        () => {
          deleteRecord(data, true);
        }
      );
    } else {
      this.openDeleteConfirmationPanel(null, false);
    }
  };

  /**
   * open activate/deactivate confirmation panel
   * @param {*} data
   * @param {*} value
   */
  openActivateDeactivateConfirmationPanel = (data, value) => {
    const { deactivationMessage, activationMessage} = this.props;
    this.setState({
      data: data,
      isOpenActivateDeactivatePanel: value,
      activeDeactivateMessage: data == null ? "" : (data.IsActive === "Yes" ? activationMessage : deactivationMessage)
    });
  };

   /**
   * activate/deactivate record
   * @param {*} isActive
   */
   activateDeactivateRecord = isActive => {
    const { activateDeactivateRecord } = this.props;
    const { data } = this.state;
    if (isActive) {
      this.setState(
        {
          isOpenActivateDeactivatePanel: false,
          data: null
        },
        () => {
          activateDeactivateRecord(data, true);
        }
      );
    } else {
      this.openActivateDeactivateConfirmationPanel(null, false);
    }
  };

  /**
   * get formatted values
   * @param {*} value
   * @param {*} format
   * @returns
   */
  getFormattedValues = (value, format, header, data) => {
    let component = <></>;
    switch ((format || "").trim()) {
      case "Text":
      case "Number":
        if (value !== null && value !== "" && value !== undefined) {
          component = <div className={"default-text"}>{value} </div>;
        }
        break;
      case "MultiSelect":
        // eslint-disable-next-line no-case-declarations
        const selectedData = sortBy(
          uniqBy(value?.split(",") || [], x => x),
          x => x
        );
        selectedData?.length <= 2
          ? (component = selectedData?.map((obj, index) => (
              <Chip
                key={"chip" + index + "c"}
                label={obj}
                style={{
                  margin: 1,
                  fontSize: "0.7rem",
                  height: "1.8rem"
                }}
              />
            )))
          : (component = (
              <>
                {selectedData?.slice(0, 2)?.map((obj, index) => (
                  <Chip
                    key={"chip" + index + "c"}
                    label={obj}
                    style={{
                      margin: 1,
                      fontSize: "0.7rem",
                      height: "1.8rem"
                    }}
                  />
                ))}
                <span
                  style={{
                    cursor: "pointer",
                    fontSize: "0.7rem"
                  }}
                  onClick={() => this.viewData(true, selectedData, header)}
                >
                  {" ...View all"}
                </span>
              </>
            ));
        break;
      case "MultiCount":
        // eslint-disable-next-line no-case-declarations
        const countData = sortBy(
          uniqBy(value?.split(",") || [], x => x),
          x => x
        );
        component = (
          <Link
            style={{ cursor: "pointer" }}
            onClick={() => this.viewData(true, countData, header, data)}
          >
            {countData?.length}
          </Link>
        );
        break;
    }
    return component;
  };

  /**
   * view details on popup
   * @param {*} isDetailsPopup
   * @param {*} selectedData
   * @param {*} header
   * @param {*} data
   * @param {*} selectedId
   */
  viewData = (isDetailsPopup, selectedData, header = "", data = null) => {
    this.setState({
      isDetailsPopup: isDetailsPopup,
      selectedData: selectedData,
      columnHeader: header,
      data: data,
      selectedRecipientId: selectedData,
      isEdit: false
    });
  };

  /**
   * call on edit or cancel icon
   * @param {*} isEdit
   */
  editRecord = (isEdit = true) => {
    this.setState({
      isEdit: isEdit
    });
  };

  /**
   * call on onchange of multiselect
   * @param {*} value
   * @param {*} name
   */
  // eslint-disable-next-line no-unused-vars
  onMultiSelectDD = (value, name, isNewOption = false, isInvalid = false) => {
    if (isNewOption) {
      value = (value || []).map(option => option["value"]);
    }

    this.setState({
      [name]: Array.isArray(value) ? value : "",
    });
  };

  /**
   * call when click on save button
   */
  saveRecord = () => {
    const { deleteRecord, inValidData } = this.props;
    const { selectedRecipientId, data, masterData } = this.state;
    if (selectedRecipientId === undefined || selectedRecipientId?.length <= 0) {
      ShowToast(
        "At least one recipient is required.",
        toastType.ERROR,
        5000,
        500
      );
    } else if (inValidData === false) {
      ShowToast(
        "Please enter valid data in field.",
        toastType.ERROR,
        5000,
        500
      );
    } else {
      data.Recipient = selectedRecipientId?.join(",");
      if (data.Recipient === "All") {
        data.Recipient = masterData?.value
          ?.filter(x => x.PropertyId === data.PropertyId)
          ?.map(x => x.DataLabel)
          ?.join(",");
      }
      this.setState(
        {
          isDetailsPopup: false,
          selectedData: [],
          columnHeader: "",
          data: null,
          selectedRecipientId: []
        },
        () => {
          deleteRecord(data);
        }
      );
    }
  };

  /**
   * get absent values from array 1
   * @param {*} arr1
   * @param {*} arr2
   * @returns
   */
  getAbsentValues = (arr1, arr2, key) => {
    let res = [];
    res = (arr1 || []).filter(el => {
      return !arr2.find(obj => {
        return el === obj[key];
      });
    });
    return res;
  };

  /**
   * render option list against dropdown
   * @param {*} selectedRecipientId
   * @param {*} masterData
   * @returns
   */
  getOptionList = (selectedRecipientId, masterData) => {
    const { data, selectedData } = this.state;
    const ele = this.getAbsentValues(
      selectedRecipientId,
      masterData?.value,
      "DataLabel"
    );
    const optionsList = convertIntoDDFormat(
      (masterData?.value || []).filter(
        z => z.PropertyId === data?.PropertyId
      ) || [],
      "DataValue",
      "DataLabel"
    );
    ele?.length > 0 &&
      ele.map(email => {
        optionsList.push({ value: email, id: -(optionsList.length + 1) });
      });
    const ele1 = this.getAbsentValues(selectedData, optionsList, "value");
    ele1?.length > 0 &&
      ele1.map(email => {
        optionsList.push({ value: email, id: -(optionsList.length + 1) });
      });
    return optionsList ? sortBy(optionsList, x => x.value) : [];
  };

    
  renderRow =(
    isInAddMode,
    index,
    columns,
    props,
    col
  ) => {
    const editableClass = props.isEditableMode ? "edit-mode" : "";

    return props.selectedEditRowId &&
    props.selectedEditRowId.value === props.updateData[props.selectedEditRowId.key] && props.isInline !== true ? (
      <TableCell
        key={"tableRowCell" + index + isInAddMode.toString()}
        colSpan={
          ((columns || []).filter(x => x.showInEditOnly !== true) || []).length
        }
        className={editableClass}
      >
        <div className={"row"} style={{ width: "100%" }}>
          <div className={"col-xs-10"}>
            <div className={"row"}>
              {_.orderBy(columns || [], ["editSortOrder"], ["asc"]).map(
                (col, i) => (
                  <>
                    {col.renderComponent === undefined &&
                      (
                        <div
                          className={"col-xs-12 col-lg-4"}
                          style={{ marginTop: "10px" }}
                          key={"edit-" + i + col.key}
                        >
                          {getFormattedData(
                            props.updateData,
                            col,
                            props.isInAddMode,
                            props.EditSource,
                            props.selectedEditRowId,
                            props.handleTableValueChange,
                            true,
                            props,
                            index,
                            props. viewTagData
                          )}
                        </div>
                      )}
                  </>
                )
              )}
            </div>
          </div>
          <div className={"col-xs-1 center-xs"}>
            {(columns || []).map(col =>
              col.renderComponent !== undefined ? (
                props[col.renderComponent] &&
                props[col.renderComponent](props.updateData, col.key, isInAddMode)
              ) : (
                <></>
              )
            )}
          </div>
        </div>
      </TableCell> ) :
      isInAddMode ?
      (columns || [])
      .filter(x => x.showInEditOnly !== true)
      .map((col, i) => (
        <TableCell
         // className={col.markRedOrGreen === true ? exceededClass : ""}
          key={"tableRowCell" + index + i + col.key}
          style={{
            width: columns.width
          }}
        >
          {col.renderComponent !== undefined
            ? props[col.renderComponent]  &&
              props[col.renderComponent](props.updateData, col.key, isInAddMode)
            : getFormattedData(
                props.updateData,
                col,
                isInAddMode,
                props.EditSource,
                props.selectedEditRowId,
                props.handleTableValueChange,
                false,
                props,
                undefined,
                props.viewTagData,
                props.showCollapsible,
                props.handelCollapsible,
                props.selected
              )}
        </TableCell>
      )) :
      <>
        {col.renderComponent !== undefined
          ? props[col.renderComponent]  &&
            props[col.renderComponent](props.updateData, col.key, isInAddMode)
          : getFormattedData(
              props.updateData,
              col,
              isInAddMode,
              props.EditSource,
              props.selectedEditRowId,
              props.handleTableValueChange,
              false,
              props,
              undefined,
              props.viewTagData,
              props.showCollapsible,
              props.handelCollapsible,
              props.selected
            )}
      </>
    
  }


  render() {
    const {
      isShowColFilter,
      refreshFilteredObj,
      reload,
      keepFilterData,
      selectedSource,
      clearData,
      selectedIds,
      pageNo,
      rowsPerPagination,
      isOpenDeleteConfirmationPanel,
      isDetailsPopup,
      selectedData,
      columnHeader,
      isEdit,
      masterData,
      selectedRecipientId,
      isOpenActivateDeactivatePanel,
      activeDeactivateMessage,
      originalData
    } = this.state;
    const {
      downloadBtnLabel,
      openUpdateDialog,
      addButtonLabel,
      toolTipData,
      downloadLink,
      downloadSSRSReport,
      tableHeader,
      columns,
      resetPage,
      backToPage,
      visibilityAction,
      isInAddMode
    } = this.props;

    const props = this.props;

    const filteredData = isShowColFilter
      ? this.getFilteredData(originalData)
      : originalData;

    return (
      <>
        <Dialog
          open={isDetailsPopup || false}
          onClose={() => this.viewData(false, [])}
          PaperComponent={PaperComponent}
          fullWidth
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {columnHeader}
              </Typography>
              <IconButton
                title={"Close"}
                edge={"start"}
                color={"inherit"}
                onClick={() => this.viewData(false, [])}
                aria-label={"close"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent>
            {selectedData &&
              !isEdit &&
              selectedData?.map((obj, index) => (
                <Chip
                  key={"chip" + index + "c"}
                  label={obj}
                  style={{ margin: 1, fontSize: "0.7rem", height: "1.8rem" }}
                />
              ))}

            {isEdit && (
              <div className={"col-xs-4"}>
                <FormControl fullWidth className={"dropdown-select"}>
                  <VirtualizedAutocomplete
                    limitTags={100}
                    className={"recipient-textBox"}
                    isSelectAll={false}
                    key={"data-center-id"}
                    parentKey={"data-center-id"}
                    header={masterData.name}
                    optionsList={(
                      this.getOptionList(selectedRecipientId, masterData) || []
                    ).filter(x => x.value !== null)}
                    selectedIds={selectedData || []}
                    minWidth={"300px"}
                    onChange={(val, isNewOption, isInvalid) =>
                      this.onMultiSelectDD(
                        val,
                        masterData.selectedIds,
                        isNewOption,
                        isInvalid
                      )}
                    isNewOption
                  />
                </FormControl>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            {!isEdit && visibilityAction.isActionVisible === true && (
              <Tooltip title={getToolTipText(toolTipData, TOOLTIP_LABEL.EDIT)}>
                <IconButton
                  aria-label={"refreshData"}
                  size={"small"}
                  onClick={this.editRecord}
                >
                  <EditIcon
                    fontSize={"small"}
                    size={"small"}
                    style={{ cursor: "pointer" }}
                  />
                </IconButton>
              </Tooltip>
            )}
            {isEdit && visibilityAction.isActionVisible === true && (
              <>
                <Tooltip
                  title={getToolTipText(toolTipData, TOOLTIP_LABEL.SAVE)}
                >
                  <IconButton
                    aria-label={"refreshData"}
                    size={"small"}
                    onClick={this.saveRecord}
                  >
                    <SaveIcon size={"small"} style={{ cursor: "pointer" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={getToolTipText(toolTipData, TOOLTIP_LABEL.CANCEL)}
                >
                  <IconButton
                    aria-label={"refreshData"}
                    size={"small"}
                    onClick={() => this.editRecord(false)}
                  >
                    <CancelIcon size={"small"} style={{ cursor: "pointer" }} />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </DialogActions>
        </Dialog>
        <ConfirmDialog
          IsOpen={isOpenDeleteConfirmationPanel}
          Message={
            <>
              <p>{commonLabels.deleteDistributionConfirmation.message}</p>
            </>
          }
          OnHandelClick={this.deleteRecord}
          AgreeText={"Yes"}
          DisAgreeText={"No"}
        />
        <div className={"row"}>
          <div className={"col-xs-10"} style={{ display: "flex" }}>
            {backToPage !== undefined && backToPage && (
              <>
                <Button
                  style={{ height: "30px" }}
                  variant={"contained"}
                  size={"small"}
                  onClick={backToPage.action}
                >
                  {backToPage.label}
                </Button>
                &nbsp;&nbsp;
              </>
            )}
            {addButtonLabel && (
              <Button
                style={{ height: "30px" }}
                variant={"contained"}
                size={"small"}
                onClick={openUpdateDialog}
              >
                {addButtonLabel}
              </Button>
            )}
            <FormControlLabel
              className={"show-filter"}
              control={
                <Checkbox
                  id={"filterCompletedOrCancelled"}
                  color={"primary"}
                  defaultValue={isShowColFilter}
                  checked={isShowColFilter}
                  onChange={event => {
                    this.setState({
                      isShowColFilter: event.target.checked,
                      colFilteredObj: [],
                      clearData: true,
                      refreshFilteredObj: !refreshFilteredObj,
                      sortByColKey: "",
                      selectedIds: {}
                    });
                  }}
                />
              }
              label={"Show Filters"}
            />
            {downloadBtnLabel && (
              <DownloadSSRSPopUp
                buttonLabel={"Print"}
                dataTip={getToolTipText(toolTipData, TOOLTIP_LABEL.DOWNLOAD)}
                reportList={[
                  {
                    label: downloadBtnLabel,
                    id: 1,
                    pdfDownload: true,
                    excelDownload: true,
                    downloadLink
                  }
                ]}
                downloadBtnLabel={TOOLTIP_LABEL.DOWNLOAD}
                downloadReport={downloadSSRSReport}
              />
            )}
            <Tooltip
              title={getToolTipText(toolTipData, TOOLTIP_LABEL.CLEAR_FILTER)}
              placement={"bottom"}
            >
              <img
                className={"icons"}
                src={FilterOff}
                alt={"logo"}
                onClick={() => {
                  this.clearFilter();
                }}
              />
            </Tooltip>
          </div>
          <div className={"col-xs-2 end-xs"}>
            <Tooltip
              title={getToolTipText(toolTipData, TOOLTIP_LABEL.REFRESH)}
              placement={"bottom"}
            >
              <IconButton size={"small"} onClick={() => resetPage()}>
                <RefreshIcon
                  style={{
                    fill: "#365E7E",
                    marginTop: "7px",
                    width: "28px",
                    height: "30px"
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>
        </div>
        <Paper>
          {props.AddNewRecord && props.AddNewRecord.visible && (
            <>
              {" "}
              <IconButton
                aria-label={"add-new-row"}
                className={"action-button"}
                size={"small"}
                onClick={() => {
                  props.AddNewRecord.action();
                }}
                disabled={props.AddNewRecord.disableAddButton || false}
              >
                <AddIcon
                  disabled={props.AddNewRecord.disableAddButton || false}
                  fontSize={"small"}
                  size={"small"}
                />
                <span className={"tool-icon-text"}>{props.AddNewRecord.title}</span>
              </IconButton>
            </>
          )}
        <TableContainer className={"routing-notification"}>
          <Table
            className={"routing-notification-table"}
            style={{ fontWeight: "200 !important" }}
          >
            <TableHead>
              <TableRow
                className={"blue-cust-title"}
                style={{ borderTop: "3px solid #FFFFFF" }}
              >
                <TableCell
                  colSpan={13}
                  style={{
                    fontSize: "15px",
                    textAlign: "center",
                    lineHeight: "25px"
                  }}
                >
                  {tableHeader}
                </TableCell>
              </TableRow>
              <TableHeaderWithFilter
                clearData={clearData}
                refreshFilteredObj={refreshFilteredObj}
                selectedId={selectedIds}
                reload={reload}
                keepFilterData={keepFilterData}
                selectedSource={selectedSource}
                columnData={columns}
                isShowFilter={isShowColFilter}
                onChangeFilter={this.updateColumnFilter}
              />
            </TableHead>
            <TableBody>
            {isInAddMode && (
                  <TableRow                    
                    key={"0"}
                    className={" add"}

                  >
                    {}
                    {this.renderRow(
                      isInAddMode,
                      0,
                      columns,
                      props
                    )}
                  </TableRow>
                )}

              {filteredData && filteredData?.length > 0 ? (
                (
                  (rowsPerPagination > 0
                    ? filteredData.slice(
                        pageNo * rowsPerPagination,
                        pageNo * rowsPerPagination + rowsPerPagination
                      )
                    : filteredData) || []
                ).map((item, index) => (
                  <TableRow key={"notificationAndRouting" + index}>
                    {columns.map((col, ind) => {
                      return (
                        <TableCell
                          key={
                            "notificationAndRouting" + index + ind + col.keyName
                          }
                          align={col.align || ""}
                        >
                          {props.selectedEditRowId &&
                                    props.selectedEditRowId.value === item[props.selectedEditRowId.key] ?
                                    this.renderRow(
                                      isInAddMode,
                                      0,
                                      columns,
                                      props,
                                      col
                                    )
                            : (props.selectedEditRowId === undefined || (props.selectedEditRowId &&
                            props.selectedEditRowId.value !== item[props.selectedEditRowId.key])) && col.noValue !== true
                            ? this.getFormattedValues(
                                item[col.keyName],
                                col.dataFormat,
                                col.header,
                                item
                              )
                            :  (props.selectedEditRowId === undefined || (props.selectedEditRowId &&
                            props.selectedEditRowId.value !== item[props.selectedEditRowId.key])) && col.noValue === true && this.renderActionColumn(col, item)}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell align={"Center"} colSpan={columns?.length}>
                    {"No data available\r"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {filteredData && filteredData.length > 0 && (
            <div className={"paginationContainer"}>
              <PaginationControlled
                tableLength={filteredData.length}
                updateRowCount={this.updateRowCount}
                pageNo={pageNo}
                rowsPerPagination={rowsPerPagination}
              />
            </div>
          )}
        </TableContainer>
        </Paper>
        <ConfirmDialog
          IsOpen={isOpenActivateDeactivatePanel}
          Message={
            <>
              <p>{activeDeactivateMessage}</p>
            </>
          }
          OnHandelClick={this.activateDeactivateRecord}
          AgreeText={"Yes"}
          DisAgreeText={"No"}
        />
      </>
    );
  }
}

export default TableWithFilter;
